# Node
import * as $ from 'jquery'
import 'inputmask'
import * as MicroModal from 'micromodal/dist/micromodal'
import * as menu from '@material/menu/index';


# Custom
import { noty_render_alert } from 'common/noty_notifications'
import { isEmailValid } from "/app/assets/javascripts/common/validation"

$.ajaxSetup headers: 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')

window.passedCaptcha = ->
  submitRequestCamp(document.getElementsByName('smart-token')[0].value);


#TODO переписать эту форму с каким нибудь фреймворком
$(document).ready ->
  Inputmask("+7 (999) 999-99-99").mask("input#phone"); # метод validatePhone зависит от этой маски!
  $("input#phone").change()
# Функция формирования объекта с параметрами заявки.

  defaultLatLng =
    lat: 55.755826
    lng: 37.6173

  form_params = ->
    params =
      name: $('#name').val()
      camp_type_id: $('#type_id').val()
      site: $('#site').val()
      region_id: $('#region_id').val()
      city_id: if $('#city_id').val()? then $('#city_id').val() else ''
      camp_id: $('#camp_id').val()
      lat:      if $('#lat').val() == defaultLatLng.lat then null else $('#lat').val()
      lng:      if $('#lng').val() == defaultLatLng.lng then null else $('#lng').val()
      phones: [$('#phone').val()].concat window.additional_phones
      email:  $('#email').val()
      person: $('#person').val()
      url: strToUrl($('#name').val())
      special_request_attributes: { message: $('#notes').val() }
      responsible_id: $('#responsible_id').val()
      additional_cities: $('.additional_city_input').map( () -> @value).get()
      statistic_channel_manager_id: $('#channel_manager').val()
      website_type: window.website_type

  strToUrl = (w) ->
    tr = 'a b v g d e j z i y k l m n o p r s t u f h c ch sh sh ~ y ~ e yu ya ~ e'.split(' ')
    ww = ''
    w = w.toLowerCase()
    i = 0
    while i < w.length
      cc = w.charCodeAt(i)
      ch = if cc >= 1072 then tr[cc - 1072] else w[i]
      ww += ch
      ++i
    ww.replace(/~/g, '').replace(/[^a-zA-Z0-9\-]/g, '-').replace(/[-]{2,}/gim, '-').replace(/^\-+/g,
        '').replace /\-+$/g, ''

  validatePhone = (objphone) ->
    # Utils::Url::ecma_to_rpca_regex_string(Phone::PHONE_REGEX)
    expr = /^\+7\s\([0-9]{3}\)\s[0-9]{3}-[0-9]{2}-[0-9]{2}$/
    if $(objphone).val().trim() == '' || !$(objphone).val().match(expr)
      $(objphone).addClass('input-error')
      return false
    else
      $(objphone).removeClass('input-error')
      return true

  validatePhones = ->
    isPhoneValid = validatePhone($('input#phone'))

    $('div#additional_phones').each((block_idx, block) ->
      $(block).find('input').each((select_idx, select) ->
        isPhoneValid &= validatePhone($(select))
      )
    )
    return isPhoneValid

  validate = (input_id, error_message) ->
    obj = $("input##{input_id}")
    if typeof obj.val() == 'string' && $(obj).val().trim() == ''

      $(obj).addClass('input-error')
      $(obj).val('')
      $(obj).attr('placeholder', error_message)
      return false
    else
      $(obj).removeClass('input-error')
      $(obj).attr('placeholder', null)
      return true

  validateEmail = ->
    obj = $('input#email')
    if isEmailValid($(obj))
      $(obj).removeClass('input-error')
      $(obj).attr('placeholder', null)
      return true
    else
      $(obj).addClass('input-error')
      $(obj).attr('placeholder', 'Укажите почту, пожалуйста')
      return false

  validatePerson = ->
    validate('person','Пожалуйста укажите Ваше имя')

  validateName = ->
    validate('name', 'Пожалуйста укажите название')

  validateType = ->
    validate('type','Пожалуйста укажите тип объекта')

  validateLocation = ->
    el = $('#open_map')
    el1 = $('#lat')
    el2 = $('#lng')
    if el1.val().trim() == '' || el2.val().trim() == ''
      el.addClass('input-error')
      return false
    else
      el.removeClass('input-error')
      return true

  # Валидация заполненности селекта
  validateSelect = (unit) ->
    el = $(unit)
    if (el.val()?.trim() == '')
      el.parent().addClass('input-error')
      return false
    else
      el.parent().removeClass('input-error')
      return true

  validation = ->
    errors = true
    errors &= validatePerson()
    errors &= validateName()
    errors &= validateType()
    errors &= validateEmail()
    errors &= validatePhones()
    errors &= validateSelect('#country_id')
    errors &= validateSelect('#region_id')
    errors &= validateSelect('#channel_manager')
    errors

  # Обрезает строку до указанной длины заменяя последние три символа на '...'
  trimToLength = (str, length) ->
    if str.length > length && length > 3
      str.substring(0, length - 3) + '...'
    else
      str

  toggle_second_step = ->
    window.scrollTo(0,0)
    $('#article').toggle()
    $('#form-wrapper').toggle()
    $('#step_2').toggle()
    $('h1').toggle()

  $('#submit_request').click ->
    if !window.smartCaptcha
      return false
    window.smartCaptcha.execute()
    return true

#    conf_marker.geometry.setCoordinates(marker.geometry.getCoordinates())
#    conf_map.setCenter(marker.geometry.getCoordinates())
#    conf_map.setZoom(11);

  $('#advance').click ->
    params = form_params()
    if validation()
      toggle_second_step()
      maxStrLength = 70
      $('#s2_type').text($("#type_id").siblings('.mdc-select__selected-text').text())
      $('#s2_name').text(trimToLength(params.name, maxStrLength))
      $('#s2_region_name').text($('#region_id').siblings('.mdc-select__selected-text').text())
      $('#s2_city_name').text(if $('#city_id').siblings('.mdc-select__selected-text').val()? then $('#city_id').siblings('.mdc-select__selected-text').text() else '')
      $('#s2_person').text(trimToLength(params.person, maxStrLength))
      $('#s2_email').text(params.email)
      $('#s2_phone').html(stringify_phones(params.phones))
      $('#s2_site').text(trimToLength(params.site, maxStrLength))
      $('#s2_notes').text(params.special_request_attributes.message)


      if params.lat != null && params.lng != null && params.lat != "" && params.lng != "" && parseFloat(params.lat) != defaultLatLng.lat && parseFloat(params.lng) != defaultLatLng.lng
        $('#s2_lng,#s2_lat').parent().show();
        $('#map_step_2').show()
        $('#s2_lng').text(Number.parseFloat(params.lng).toFixed(4))
        $('#s2_lat').text(Number.parseFloat(params.lat).toFixed(4))
      else
        $('#s2_lng,#s2_lat').parent().hide();
        $('#map_step_2').hide();


      if params.site.length < 1
        $('#s2_site').parent().css('display','none')
      if params.special_request_attributes.message.length < 1
        $('#s2_notes').parent().css('display','none')

  $('#retreat').click ->
    toggle_second_step()

  # --------------- additional_phones ---------------
  # Дополнительные номера телефонов
  window.additional_phones = []

  additional_phone_div = '
      <div class="mdc-text-field main-form-input m-t-5">
        <input type="text"
               name="additional_phone"
               id="additional_phone"
               class="mdc-text-field__input"
               placeholder="+7 (301) 123-45-67"
               onchange="additional_phone_changed(this)"
        >
        <div class="mdc-line-ripple"></div>
      </div>
  '
  # Для отображения в на странице в форме
  stringify_phones = (phones_params) ->
    phones_string = ''
    for key, value of phones_params
      phones_string = phones_string + value + "<br>"
    return phones_string

  $('#add_phone').click ->
    add_additional_phone()
    Inputmask("+7 (999) 999-99-99").mask("input#additional_phone");

  add_additional_phone = () ->
    # Сохранить пустой элемент
    window.additional_phones.push(0)
    # Добавить input
    $additional_phones_blocks = $('div#additional_phones')
    $additional_phones_blocks.append(additional_phone_div)

  window.remove_additional_phone = (dom) ->
    idx = $(dom).closest('#additional_phones').find('div.form-row').index($(dom).closest('div.form-row'))
    window.additional_phones.splice(idx, 1)
    $additional_phones_blocks = $('div#additional_phones')
    # Удалить из копии формы вверху страницы
    $($additional_phones_blocks[0]).find('div.form-row')[idx].remove()
    # Удалить из копии формы внизу страницы
    $($additional_phones_blocks[1]).find('div.form-row')[idx].remove()

  window.additional_phone_changed = (dom) ->
    $select = $(dom)
    # Сохранить номер телефона
    idx = $select.closest('#additional_phones').find('input').index($select)

    window.additional_phones[idx] = $select.val()

    $additional_phones_blocks = $('div#additional_phones');

    $additional_phones_blocks.each((block_idx, block) ->
      $(block).find('input').each((select_idx, select) ->
        $(select).val(window.additional_phones[select_idx])
      )
    )

    validatePhones()

  # --------------- additional_cities ---------------
  # Дополнительные города

  #модель данных дополнительных городов

  $('#add_nearby_city').click ->
    $('.mdc-select.hidden').first().removeClass('hidden')
    $('#add_nearby_city').hide() if $('.mdc-select.hidden').length == 0



  window.submitRequestCamp = (token) ->
    book_new_camp = form_params()
    if validation()
      $("#submit_request").attr("disabled", true)
      $.ajax
        url: window.website_prefix + '/book_new_camps'
        type: 'POST'
        data: {
          book_new_camp: book_new_camp,
          captcha_token: token
        }
        complete: ->
          $('.submit_request').attr("disabled", false);
        success: (data, textStatus, jqXHR) ->
          toggle_second_step()
          $('#article').html(data)
          $('#form-wrapper').css('display','none')
        error: (data) ->
          noty_render_alert('error', "Ошибка отправки заявки!\nПопробуйте отправить заявку позднее.")

    return false

  $('.ui-dialog-buttonset').children().addClass('button')
  $('.ui-dialog-buttonset').css('text-align','center')

  $('input#phone').on('blur change', ->
    $("input#phone").val($(this).val())
    validatePhones()
  )

  $('input#email').on('blur change keyup', ->
    $('input#email').val($(this).val())
    validateEmail()
  )

  $('input#person').on('blur change keyup', ->
    validatePerson()
  )

  $('input#name').on('blur change keyup', ->
    validateName()
  )

  $('#open_map').on('click', (e) ->
    e.preventDefault()
    MicroModal.show('map-modal')
    map.setCenter(marker.geometry.getCoordinates())
    map.setZoom(11);
  )


# Класс вывода городов в зависимости от выбранного региона.
class ShowCitiesByRegion
  # Конструктор класса.
  # country_html_id - Идентификатор DOM элемента, выводящего список стран. Передается в формате '#id'.
  # region_html_id - Идентификатор DOM элемента, выводящего список регионов. Передается в формате '#id'.
  # city_html_id - Идентификатор DOM элемента, выводящего список городов. Передается в формате '#id'.
  constructor: (country_html_id, region_html_id, city_html_id) ->
    @country = $(country_html_id)
    country_menu = "#{country_html_id}_menu"
    _menu = new menu.MDCMenu(document.querySelector(country_menu))
    _menu.listen 'MDCMenu:selected', (d) =>
      @update_regions()

    @region = $(region_html_id)
    @region_list = $("#{region_html_id}_list")
    region_menu = "#{region_html_id}_menu"
    _menu = new menu.MDCMenu(document.querySelector(region_menu))
    _menu.listen 'MDCMenu:selected', (d) =>
      @update_cities()

    @city_html_id = city_html_id

# Метод вставки регионов в форму для текущей страны.
# data - Массив регионов.
  insert_regions: (data) ->
    $('#open_map').prop('disabled', true)

    @region_list.empty()
    $('#region_id').siblings('.mdc-select__selected-text').text('')
    $('#region_id').val('')
    @insert_cities()

    if $('#country_id').val() == ''
      $('#region_id').parent().addClass('mdc-select--disabled')
    else
      $('#region_id').parent().removeClass('mdc-select--disabled')
      @region_list.append "<li class=\"mdc-list-item\" data-value=\"#{item.id}\">#{item.name}</li>" for item in data


# Метод вставки городов в форму для текущего региона.
# data - Массив городов.
  insert_cities: (data) ->
    $(@city_html_id).empty()
    $('#city_id').siblings('.mdc-select__selected-text').text('')
    $('#city_id').val('')
    $('.additional_city_input').siblings('.mdc-select__selected-text').text('')
    $('.additional_city_input').val('')
    $('#additional_cities').find('.mdc-select').addClass('hidden')
    $('#add_nearby_city').show()


    if $('#region_id').val() == ''
      $('#city_id').parent().addClass('mdc-select--disabled')
      $('#open_map').prop('disabled', true)
    else
      $('#city_id').parent().removeClass('mdc-select--disabled')
      $('#open_map').prop('disabled', false)
      if data?
        $(@city_html_id).append "<li class=\"mdc-list-item\" data-value=\"#{item.id}\">#{item.name}</li>" for item in data

# Метод изменения массива регионов.
  update_regions: ->
    value = @country.val()
    if value == ''
      @insert_regions []
      return
    if @current_country == value
      return
    @current_country = value
    request = $.ajax
      url: window.website_prefix + '/countries/get_regions'
      type: 'POST'
      data:
        country_id: value
      success: (data, textStatus, jqXHR) =>
        @insert_regions data
      error: (jqXHR, textStatus, errorThrown) ->
        render_alert_msg 'При загрузке списка городов с сервера произошла ошибка', 'danger'
      dataType: 'json'

# Метод изменения массива городов.
  update_cities: ->
    value = @region.val()
    if value == ''
      @insert_cities []
      return
    if @current_region == value
      return
    @current_region = value
    request = $.ajax
      url: window.website_prefix + '/regions/get_cities'
      type: 'POST'
      data:
        region_id: value
      success: (data, textStatus, jqXHR) =>
        @insert_cities data
      error: (jqXHR, textStatus, errorThrown) ->
        render_alert_msg 'При загрузке списка городов с сервера произошла ошибка', 'danger'
      dataType: 'json'

$(document).ready ->
  cities = new ShowCitiesByRegion '#country_id', '#region_id', '.city_id_list'
